import { useQuery } from 'react-query';

import { MIME_TYPES, STALE_TIME } from '@savgroup-front-common/constants';

import { CommonAttachmentService } from '../../../../api';
import {
  FileAttachmentUploadLink,
  SessionType,
} from '../../../../api/Attachment/getFilesUploadLinksBySessionIdCommand';
import { useAdditionalInformationContext } from '../../AdditionalInformation.context';

export const useQrCodeImportModal = ({
  onSuccess,
  additionalInformationId,
  claimId,
  allowedMimeTypes,
  sessionType,
}: {
  onSuccess: (fileAttachmentUploadLink: FileAttachmentUploadLink) => void;
  additionalInformationId: string;
  claimId: string;
  allowedMimeTypes?: MIME_TYPES[];
  sessionType: SessionType;
}) => {
  const { sellerId, fileReference } = useAdditionalInformationContext();

  const { data, isLoading } = useQuery(
    ['getFilesUploadLinksBySessionIdCommand', { sellerId }],
    async () => {
      const response =
        await CommonAttachmentService.getFilesUploadLinksBySessionIdCommand({
          sellerId,
          type: sessionType,
          metaData: {
            additionalInformationId,
            claimId,
            fileReference,
          },
          allowedMimeTypes,
        });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    {
      suspense: true,
      staleTime: STALE_TIME.MS_100,
      refetchOnMount: 'always',
      onSuccess,
    },
  );

  return {
    uploadQrCode: data?.uploadQrCode,
    uploadUrl: data?.uploadUrl,
    isLoading,
    sessionId: data?.sessionId,
  };
};
